module.exports = __webpack_public_path__ + "static/media/Sero Bazaar.edbde99e.png";